import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useSignIn } from '@/hooks/use-auth'
import { AimeLogo } from '@/components/AimeLogo'

export default function SignInPage() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const signIn = useSignIn()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    signIn.mutate(
      { email, password },
      {
        onSuccess: () => navigate('/', { replace: true }),
      },
    )
  }

  return (
    <div className="flex min-h-dvh flex-col items-center justify-center p-6">
      <div className="w-full max-w-sm space-y-6">
        <div className="flex flex-col items-center gap-3 text-center">
          <AimeLogo size={120} />
          <h1 className="sr-only">Aime — {t('auth.signIn')}</h1>
          <p className="text-on-surface-variant text-sm">The CRM for everyday relationships.</p>
          <p className="text-on-surface-variant mt-1">{t('auth.signIn')}</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="text-sm font-medium" htmlFor="email">
              {t('auth.email')}
            </label>
            <input
              id="email"
              type="email"
              required
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="border-outline-variant/30 bg-surface-container ring-offset-background focus-visible:ring-ring mt-1 flex h-10 w-full rounded-xl border px-3 py-2 text-sm focus-visible:ring-2 focus-visible:outline-none"
            />
          </div>
          <div>
            <label className="text-sm font-medium" htmlFor="password">
              {t('auth.password')}
            </label>
            <input
              id="password"
              type="password"
              required
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="border-outline-variant/30 bg-surface-container ring-offset-background focus-visible:ring-ring mt-1 flex h-10 w-full rounded-xl border px-3 py-2 text-sm focus-visible:ring-2 focus-visible:outline-none"
            />
          </div>

          <div className="flex justify-end">
            <Link to="/forgot-password" className="text-primary text-xs hover:underline">
              {t('auth.forgotPassword')}
            </Link>
          </div>

          {signIn.error && <p className="text-destructive text-sm">{signIn.error.message}</p>}

          <button
            type="submit"
            disabled={signIn.isPending}
            className="bg-primary text-primary-foreground hover:bg-primary/90 inline-flex h-10 w-full items-center justify-center rounded-xl px-4 py-2 text-sm font-medium disabled:opacity-50"
          >
            {signIn.isPending ? '...' : t('auth.signIn')}
          </button>
        </form>

        <p className="text-on-surface-variant text-center text-sm">
          {t('auth.noAccount')}{' '}
          <Link to="/sign-up" className="text-primary hover:underline">
            {t('auth.signUp')}
          </Link>
        </p>
      </div>
    </div>
  )
}
